export { default as Statistic } from './Statistic';
